import { configureStore } from '@reduxjs/toolkit';
import userReducer from './userSlice';
import eventReducer from '../../component/mainLayout/eventSlice';
import { loadState, saveState } from './localStorage';

const persistedState = loadState();

const store = configureStore({
  reducer: {
    user: userReducer,
    event: eventReducer,
  },
  preloadedState: persistedState,
});

// Save Redux state to localStorage on every change
store.subscribe(() => {
  saveState({
    user: store.getState().user,
    event: store.getState().event,
  });
});

export default store;
